module.exports = __webpack_public_path__ + "static/media/leaf-filled.611f3d6f.svg";